/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Add: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M23 9H15V1C15 0.4 14.6 0 14 0H10C9.4 0 9 0.4 9 1V9H1C0.4 9 0 9.4 0 10V14C0 14.6 0.4 15 1 15H9V23C9 23.6 9.4 24 10 24H14C14.6 24 15 23.6 15 23V15H23C23.6 15 24 14.6 24 14V10C24 9.4 23.6 9 23 9Z'
      fill='currentColor'
    />
  </React.Fragment>
)
